<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
</div>
<form name="form" #form="ngForm">
    <div class="modal-body">
        <div class="row">
            <div class="col-6">
                <div class="form-group">
                    <label for="heavyBidNum">Heavy Bid #</label>
                    <input type="number" id="heavyBidNum" class="form-control" [(ngModel)]="target.heavyBidNum" name="heavyBidNum" />
                </div>
            </div>
            <div class="col-6">
                <div class="form-group">
                    <label for="bidDate">Bid Date</label>
                    <wj-input-date id="bidDate" [(ngModel)]="target.bidDate" name="bidDate"></wj-input-date>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="job">Job</label>
                    <input type="text" id="job" class="form-control" [(ngModel)]="target.job" name="job" />
                </div>
            </div>
        </div>
        @if (target.bidAbstracts && target.bidAbstracts.length > 0) {
            <div class="row">
                <div class="col-12">
                    <label for="existing-abstracts">Existing Abstracts</label>
                    <ul class="list-group list-group-flush">
                        @for (item of target.bidAbstracts; track item.id) {
                            <li class="list-group-item px-0">
                                <a href="javascript:void(0)" (click)="openAbstract(item.url)">{{ item.fileName }}</a>
                            </li>
                        }
                    </ul>
                </div>
            </div>
        }
        @if (pendingFiles.length > 0) {
            <div class="row mt-2">
                <div class="col-12">
                    <label for="files-to-upload">Files To Upload</label>
                    <ul class="list-group list-group-flush">
                        @for (file of pendingFiles; track file.name) {
                            <li class="list-group-item px-0 d-flex align-items-center justify-content-between">
                                <span>{{ file.name }}</span>
                                <button type="button" class="btn btn-sm btn-outline-danger" (click)="removeFile(file)">
                                    <fa-icon [icon]="faX" size="xs"></fa-icon>
                                </button>
                            </li>
                        }
                    </ul>
                </div>
            </div>
        }
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-success" style="margin-right: auto" (click)="fileInput.click()">Upload Abstract</button>
        <input
            style="display: none"
            type="file"
            (change)="onFileChanged($event)"
            accept=".pdf,.doc,.docx,.xls,.xlsx,.txt,.csv,.ppt,.pptx"
            #fileInput
            multiple
        />
        <button id="btnSave" type="submit" class="btn btn-primary" (click)="save()" [disabled]="form.invalid || isSaving">
            @if (isSaving) {
                <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Saving</span>
            } @else {
                <span>Save</span>
            }
        </button>
        <button id="btnCancel" type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="isSaving">Cancel</button>
    </div>
</form>
